// extracted by mini-css-extract-plugin
export default {"block":"Hjyo57GrDtvXigBfKcth","banner":"A6lQlpCDeBE8bRzcuIVS","buttons":"kaaGL823usKLtqjv7tmQ"};